/**
 * Returns the hash containing the codes and languages as key/value pairs.
 */
export default function() {
  return { en: 'English' };
}
